import React from "react";

export function Subheadline() {
  return (
    <p className="description__text">
      Built my first websites at 14. Spent twelve years studying and practicing
      architecture. Then came back to code — for good this time. Currently a
      Software Engineer at{" "}
      <a href="https://www.liqid.de" className="website_link">
        LIQID
      </a>
      . Sensitive to beauty and detail, occasionally overwhelmed by both.
    </p>
  );
}
